import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, type Identity } from './AuthProvider';
import { LoadingState } from '../../design-system/components/LoadingState';

interface RequireAuthProps {
  children: React.ReactNode;
  /** Restrict to a specific identity type. If omitted, any auth is OK. */
  requireType?: Identity['type'];
}

export function RequireAuth({ children, requireType }: RequireAuthProps) {
  const { identity, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><LoadingState variant="page" /></div>;
  }
  if (!identity) {
    const loginPath = requireType === 'super_admin' ? '/admin/login' : '/login';
    return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
  }
  if (requireType && identity.type !== requireType) {
    return <Navigate to={identity.type === 'super_admin' ? '/admin' : '/dashboard'} replace />;
  }
  return <>{children}</>;
}
